import { render } from "./EmailUpdate.vue?vue&type=template&id=d2d2c58a"
import script from "./EmailUpdate.vue?vue&type=script&lang=js"
export * from "./EmailUpdate.vue?vue&type=script&lang=js"
script.render = render

export default script